var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.5C2 1 2.5 0.5 3 0.5H10C10.5 0.5 11 1 11 1.5V12.5H10H4C3 12.5 2 11.5 2 10.5V1.5ZM3 1.5V10.5C3 11 3.5 11.5 4 11.5H10V1.5H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5C13.7761 4.5 14 4.72386 14 5V15.5L5.5 15.5C5.22386 15.5 5 15.2762 5 15C5 14.7239 5.22386 14.5 5.5 14.5L13 14.5V5C13 4.72386 13.2239 4.5 13.5 4.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a97cd8732762102820f187e1edb340fc.svg";
export { ForwardRef as ReactComponent };